var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "qty form-group row no-gutters" }, [
    _vm.hasLabel
      ? _c("label", { staticClass: "col-5 col-lg-4 col-form-label" }, [
          _vm._v("Quantité ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { class: _vm.hasLabel ? "col-7 col-lg-8" : "col-12 col-lg-12" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-default float-left",
          attrs: { type: _vm.buttonType },
          on: {
            click: function($event) {
              --_vm.quantity
            }
          }
        },
        [_vm._v("-")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.quantity,
            expression: "quantity"
          }
        ],
        staticClass: "form-control float-left",
        attrs: { type: "number", placeholder: "1" },
        domProps: { value: _vm.quantity },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.quantity = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-default float-left",
          attrs: { type: _vm.buttonType },
          on: {
            click: function($event) {
              ++_vm.quantity
            }
          }
        },
        [_vm._v("+")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35c5d33f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35c5d33f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/CartQuantity.vue
// module id = 513
// module chunks = 1